import Component from '../abstracts/Component';
import Vex from "vex-js";

Vex.registerPlugin(require('vex-dialog'));
Vex.defaultOptions.className = 'vex-theme-default';

export default class AddToCartComponent extends Component {

  get SELECTORS() {
    return {
      main: '.js-addtocart',
      actions: '.product-actions',
      notifyForm: '.notify-form',
      notifyCta: '.product-item .js-notifyme-btn',
      error: '.js-addtocart-notification',
      unavailableSize: '.js-unavailable-size',
    };
  }

  get CLASSES() {
    return {
      show: 'show'
    };
  }

  constructor() {
    super();

    this.mainTarget = $(this.SELECTORS.main);
    this.actions = $(this.SELECTORS.actions);
    this.notifyForm = $(this.SELECTORS.notifyForm);
    this.error = $(this.SELECTORS.error);
    this.isNotifyMeEnabled = $('body').data('isNotifyMeEnabled');
  }

  enableBtn(button) {
    let baseCode = $(button).data('baseCode');
    let addtocart = $(`${this.SELECTORS.main}[data-code="${baseCode}"]`)
    let msg = this.mainTarget.data('addtocart-label');
    addtocart.removeClass('cta-selectsize');
    addtocart.find('span').text(msg);
    addtocart.data('enabled', true);
    addtocart.removeAttr("disabled");
  }

  disableBtn(button){ //selectSizeBtn
    // check
    if (button.length === 0) return false;
    // ctx
    let ctx = this;
    button.each(function(i,v){
      if (!$(this).data('enabled')){
        let addtocart = $(this);
        let msg = ctx.mainTarget.data('notification');
        addtocart.addClass('cta-selectsize');
        addtocart.find('span').text(msg);
        addtocart.data('enabled', false);
      }
    });
  }


  updateProductCode(button) {
    let $elem = $(button);
    let baseCode = $elem.data('baseCode');
    let variantCode = $elem.data('code');
    let variantValue = $elem.data('value');
    let addtocart = $(`${this.SELECTORS.main}[data-code="${baseCode}"]`);
    addtocart.data('code', variantCode );
    addtocart.data('value', variantValue );
    this.log(variantCode);
  }

  sizeNotification(ev) {
    let $elem = $(ev.payload);
    let msg = $elem.data('notification');
    $elem.addClass('cta-selectsize');
    $elem.find('span').text(msg);
  }

  showUnavailableForm(button) {
    let code = $(button).data('baseCode');
    let inQuickBuy = $(button).closest('.modal-quick-buy').length == 1;
    $(`.notify-form[data-code="${code}"]`).addClass(this.CLASSES.show);
    if (this.$matchMedia('sm', null)) {
      this.$emit(this.$customEvents.BACKDROP_EVENTS.show, {classes: 'dark', inModal: inQuickBuy});
      $(`${this.SELECTORS.main}[data-product-code="${code}"]`).data('enabled', false);
    }

  }

  hideUnavailableForm(button) {
    let code = $(button).data('baseCode');
    $(`.notify-form[data-code="${code}"]`).removeClass(this.CLASSES.show);
  }


  bindEvents() {
    let ctx = this;

    //click on addtocart
    $('body').on('click.addToCart', ctx.SELECTORS.main, function(e) {
      e.preventDefault();

      let $this = $(this);
      let elemData = $this.data();
      let sendRequest = elemData.enabled || elemData.uniqueSize ;

      if(!sendRequest) {
        ctx.$emit(ctx.$customEvents.PRODUCT_EVENTS.sizerequired, $this)
      } else {
        ctx.$emit(ctx.$customEvents.PRODUCT_EVENTS.addtocart, {button: $this})
      }
    })

    $('body').on('keyup.dropdown', ctx.SELECTORS.main, function(e) {
      e.preventDefault();
      e.stopPropagation(); // evita che il layer della wishlist si chiuda selezionando "add to cart" da tastiera
    })

    //click on notify me btn in wishlist
    $('body').on('click.notifyMe', ctx.SELECTORS.notifyCta, function(e) {
      e.preventDefault();
      if (!ctx.isNotifyMeEnabled) {
        return;
      }
      if ($(this).data('noSizes') && !$(this).data('sizeSet')) {
        ctx.$emit(ctx.$customEvents.PRODUCT_EVENTS.sizerequired, this)
      } else {
        ctx.$emit(ctx.$customEvents.PRODUCT_EVENTS.notifyme, this)
      }
    })

    //click on notify me btn in cart bar
    $('body').on('click.notifyMe', '.cart-bar .js-notifyme-btn', function(e) {

      if (ctx.$matchMedia('sm', null)) {
        e.preventDefault();
        if ($(this).data('noSizes') && !$(this).data('sizeSet')) {
          ctx.$emit(ctx.$customEvents.PRODUCT_EVENTS.sizerequired, this)
        } else {
          ctx.$emit(ctx.$customEvents.PRODUCT_EVENTS.notifymeuniquesize, this)
        }
      }
    })

    this.$on(this.$customEvents.PRODUCT_EVENTS.notifymeuniquesize, ({event, payload}) => {
      let code = $(payload).data('productCode');
      $(`.notify-form[data-code="${code}"]`).addClass(this.CLASSES.show);
      if (this.$matchMedia('sm', null)) {
        this.$emit(this.$customEvents.BACKDROP_EVENTS.show, {classes: 'dark', inModal: false});
        $(`${this.SELECTORS.main}[data-product-code="${code}"]`).data('enabled', false);
      }
    });

    this.$on(this.$customEvents.PRODUCT_EVENTS.sizerequired, (e) => {
      this.sizeNotification(e);
    });


    this.$on(this.$customEvents.PRODUCT_EVENTS.sizechanged, ({event, payload}) => {

      ctx.updateProductCode(payload.button);
      ctx.hideUnavailableForm(payload.button);
      $(this.SELECTORS.unavailableSize).removeClass("show");
      if (!$(payload.button).data('disabled')) {
        ctx.enableBtn(payload.button);
      }

    });

    this.$on(this.$customEvents.PRODUCT_EVENTS.addtocart, ({event, payload}) => {

      let $elem = $(payload.button);
      this.$emit(this.$customEvents.LOADER_EVENTS.showLocal, {
        button: $elem,
        loadertype: $elem.data('loaderLocal')
      })

      $elem.attr("disabled", true);

      $.ajax({
        url:  $elem.data('href'),
        data: $elem.data(),
        dataType: "html",
        success: function (data) {
          if(data == 650){
            var remoteHref = $elem.data('exceeded-cart-qty');
            if(!isNaN($elem.data('product-code'))){
              remoteHref = remoteHref + $elem.data('product-code');
            }else if(!isNaN($elem.data('base-code'))){
              remoteHref = remoteHref + $elem.data('base-code');
            }else{
              remoteHref = remoteHref + $elem.data('code');
            }

            $.ajax({
              url: remoteHref,
              dataType: "html",
              success: function(html) {
                $elem.attr("disabled", false);
                ctx.$emit(ctx.$customEvents.MODAL_EVENTS.show, {
                  unsafeContent: html,
                  modalClass: 'exceeded-cart-products'
                })
                console.info("[AddToCart] Exceed product max number on cart.")
              },
              error: function(xhr) {
                $elem.attr("disabled", false);
                console.error("[AddToCart]", xhr, arguments);
              }
            });
          } else {
            // console.log(data);
            $elem.attr("disabled", false);
            ctx.$emit(ctx.$customEvents.PRODUCT_EVENTS.addedtocart, {
              button: $elem
            });
          }

          ctx.$emit(ctx.$customEvents.LOADER_EVENTS.hideLocal, {button: $elem})
          ctx.$emit(ctx.$customEvents.SIZES_EVENTS.sizesclose, {layer: $('.js-sizes')})

          if($('.js-product-item').length == 1) {
            setTimeout(() => {
              ctx.$emit(ctx.$customEvents.PRODUCT_EVENTS.productitemopen, {button: $elem})
            }, 1000);
          }
        },
        error: function (xhr) {
          ctx.$emit(ctx.$customEvents.LOADER_EVENTS.hideLocal, { button: $elem} )

          if (xhr.status == '510') {
            var remoteHref = $elem.data('remote-unavailable') + $elem.data('code');
            $.ajax({
              url: remoteHref,
              dataType: "html",
              success: function(html) {
                $elem.attr("disabled", false);
                ctx.$emit(ctx.$customEvents.MODAL_EVENTS.show, {
                  unsafeContent: html,
                  modalClass: 'product-not-available'
                })
              },
              error: function(xhr) {
                $elem.attr("disabled", false);
                console.error("[AddToCart]", xhr, arguments);
              }
            });
          } else {
            $elem.attr("disabled", false);
            //ctx.error.html(xhr.responseText);
            ctx.error.html('Error in addtocart');
            console.error("[AddToCart]", xhr, arguments);
          }
        }
      });

    });

    this.$on(this.$customEvents.PRODUCT_EVENTS.notifyme, ({event, payload}) => {
      ctx.showUnavailableForm(payload.button);
    });

    this.$on(this.$customEvents.PRODUCT_EVENTS.disableButton, ({event}) => {
      $(this.SELECTORS.main).each(function() {
        ctx.disableBtn(this);
      });
    });

    this.$on(this.$customEvents.PRODUCT_EVENTS.disableProductButton, ({event,payload}) => {
        let baseCode= payload.button.data('baseCode');
        ctx.disableBtn($(`${this.SELECTORS.main}[data-product-code="${baseCode}"]`));
    });

    this.$on('click.closeItem', ({event}) => {
      let $this = $(event.currentTarget);
      let $layer = $this.closest('.js-product-item');
      ctx.$emit(ctx.$customEvents.PRODUCT_EVENTS.productitemclose, { layer: $layer } )
    }, 'body', `${'.js-product-item'} .js-close-item`);

    this.$on(this.$customEvents.BACKDROP_EVENTS.hide, ({event, payload}) => {
      this.$emit(this.$customEvents.PRODUCT_EVENTS.productitemclose, { layer: '.js-product-item', fromBd: true } )
    });

    this.$on(this.$customEvents.PRODUCT_EVENTS.productitemopen, ({event, payload}) => {
      let baseCode = payload.button.data('productCode');
      let variantValue = payload.button.data('value');
      let $parent = $(`[data-cartbar][data-basecode="${baseCode}"]`);
      if (typeof variantValue === 'undefined') {
        $parent = $(`[data-cartbar][data-basecode]`);
      }
      let inQuickBuy = $parent.closest('.modal-quick-buy').length == 1;
      let $el = $parent.find('.js-product-item');
      $el.addClass(ctx.CLASSES.show);
      let productItemSize = $el.find('.product-item-size');
      if (variantValue) {
        productItemSize.text(productItemSize.data('message') + ' ' + variantValue);
      }
      if (ctx.$matchMedia('sm', null)) ctx.$emit(ctx.$customEvents.BACKDROP_EVENTS.show, {classes: 'dark', inModal: inQuickBuy});
    });

    this.$on(this.$customEvents.PRODUCT_EVENTS.productitemclose, ({event, payload}) => {
      $(payload.layer).removeClass(ctx.CLASSES.show);
      if (this.$matchMedia('sm', null) && !payload.fromBd) this.$emit(this.$customEvents.BACKDROP_EVENTS.hide);
      if ($(window).width() < 768) {
        this.disableBtn($(this.SELECTORS.main));
      }
    });

  }

  render() {
    this.disableBtn($(this.SELECTORS.main));
    this.bindEvents();
  }
}
